if (!customElements.get('gg-coffee-discovery')) {
  customElements.define('gg-coffee-discovery', class extends HTMLElement {
    connectedCallback() {
      if (this.events) return;
      this.track = this.querySelector('.ggl-discovery-track');
      this.previous = this.querySelector('[data-discovery-prev]');
      this.next = this.querySelector('[data-discovery-next]');
      this.toggle = this.querySelector('[data-discovery-toggle]');
      this.controls = this.querySelector('.ggl-discovery-controls');
      this.status = this.querySelector('[data-discovery-status]');
      if (!this.track || !this.previous || !this.next || !this.toggle) return;
      this.events = new AbortController();
      const options = { signal: this.events.signal };
      this.motion = matchMedia('(prefers-reduced-motion: reduce)');
      this.paused = this.motion.matches;
      this.inView = false;
      this.hovered = false;
      this.focused = this.contains(document.activeElement);
      this.direction = 1;
      this.previous.addEventListener('click', () => this.manual(-1), options);
      this.next.addEventListener('click', () => this.manual(1), options);
      this.toggle.addEventListener('click', () => { this.paused = !this.paused; this.syncPlayback(); }, options);
      this.addEventListener('pointerenter', event => {
        if (event.pointerType !== 'touch') { this.hovered = true; this.schedule(); }
      }, options);
      this.addEventListener('pointerleave', () => { this.hovered = false; this.schedule(); }, options);
      this.addEventListener('focusin', () => { this.focused = true; this.schedule(); }, options);
      this.addEventListener('focusout', () => {
        queueMicrotask(() => { this.focused = this.contains(document.activeElement); this.schedule(); });
      }, options);
      this.track.addEventListener('pointerdown', () => this.pause(), options);
      this.track.addEventListener('wheel', () => this.pause(), { ...options, passive: true });
      this.track.addEventListener('scroll', () => this.update(), { ...options, passive: true });
      this.track.addEventListener('keydown', event => {
        if (event.target !== this.track || !['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) return;
        event.preventDefault(); this.pause();
        if (event.key === 'Home') this.go(0);
        else if (event.key === 'End') this.go(this.track.scrollWidth);
        else this.move(event.key === 'ArrowRight' ? 1 : -1);
      }, options);
      document.addEventListener('visibilitychange', () => this.schedule(), options);
      this.motion.addEventListener('change', () => {
        if (this.motion.matches) this.paused = true;
        this.syncPlayback();
      }, options);
      this.visibility = new IntersectionObserver(entries => {
        this.inView = entries[0].isIntersecting && entries[0].intersectionRatio >= 0.2; this.schedule();
      }, { threshold: 0.2 });
      this.visibility.observe(this);
      this.resize = new ResizeObserver(() => { this.update(); this.schedule(); });
      this.resize.observe(this.track);
      this.update(); this.syncPlayback();
    }
    pause() { this.paused = true; this.syncPlayback(); }
    manual(direction) { this.pause(); this.move(direction); }
    syncPlayback() {
      this.toggle.textContent = this.paused ? 'Play' : 'Pause';
      this.toggle.setAttribute('aria-label', this.paused ? 'Start automatic coffee scrolling' : 'Pause automatic coffee scrolling');
      this.status.setAttribute('aria-live', this.paused ? 'polite' : 'off');
      this.schedule();
    }
    schedule() {
      clearTimeout(this.autoTimer);
      if (!this.isConnected || this.paused || this.hovered || this.focused || !this.inView || document.hidden || this.track.scrollWidth - this.track.clientWidth < 2) return;
      this.autoTimer = setTimeout(() => {
        const maximum = this.track.scrollWidth - this.track.clientWidth;
        if (this.track.scrollLeft >= maximum - 2) this.direction = -1;
        if (this.track.scrollLeft <= 2) this.direction = 1;
        this.move(this.direction); this.schedule();
      }, 7000);
    }
    move(direction) {
      const first = this.track.firstElementChild;
      const gap = parseFloat(getComputedStyle(this.track).columnGap) || 0;
      this.go(this.track.scrollLeft + direction * ((first?.getBoundingClientRect().width || this.track.clientWidth) + gap));
    }
    go(left) {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.track.scrollTo({ left: Math.max(0, Math.min(left, maximum)), behavior: this.motion.matches ? 'instant' : 'smooth' });
    }
    update() {
      const maximum = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      this.controls.hidden = maximum < 2;
      this.previous.disabled = this.track.scrollLeft <= 2;
      this.next.disabled = this.track.scrollLeft >= maximum - 2;
      clearTimeout(this.statusTimer);
      this.statusTimer = setTimeout(() => {
        const bounds = this.track.getBoundingClientRect();
        const cards = [...this.track.children];
        const visible = cards.map((card, index) => ({ index, box: card.getBoundingClientRect() })).filter(item => item.box.right > bounds.left + 8 && item.box.left < bounds.right - 8);
        if (visible.length) this.status.textContent = `Coffees ${visible[0].index + 1}–${visible[visible.length - 1].index + 1} of ${cards.length}`;
      }, 180);
    }
    disconnectedCallback() {
      this.events?.abort(); this.events = null;
      this.resize?.disconnect(); this.visibility?.disconnect();
      clearTimeout(this.statusTimer); clearTimeout(this.autoTimer);
    }
  });
}
